import styled from 'styled-components'

import { FilterIcon } from '@root/shared/ui-kit/icons'

import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  active: boolean
  onClick?: () => void
  size?: number
} & ClassNameProps

export const FilterButton: React.FC<Props> = ({
  className,
  active,
  onClick,
  size = 16,
}) => {
  return (
    <Root className={className} aria-checked={active} onClick={onClick}>
      <FilterIcon size={size} />
    </Root>
  )
}

const Root = styled.div`
  all: unset;
  display: grid;
  align-items: center;
  justify-content: center;

  color: var(--text-10);
  transition: color 0.2s ease-in-out;
  cursor: pointer;

  &[aria-checked='false'] {
    &:hover {
      color: var(--text-11);
    }
  }
  &[aria-checked='true'] {
    color: var(--primary-9);
  }
`
